import { render, staticRenderFns } from "./schoolData.vue?vue&type=template&id=a6542f02&scoped=true&"
import script from "./schoolData.vue?vue&type=script&lang=js&"
export * from "./schoolData.vue?vue&type=script&lang=js&"
import style0 from "./schoolData.vue?vue&type=style&index=0&id=a6542f02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6542f02",
  null
  
)

export default component.exports